/* Load Modules */
import { memoize } from "lodash";

/* Load Constants */
import {
    checkRenderForProvider,
    checkDefaultForType,
    getNewGeneratedId,
    uuidv4
} from "../../../../../../../utils/utils";

export const defaultsGlobalJackpot = memoize(({ schema }) => {
    let defaults = {};
    defaults["terminal_groups"] = [];
    defaults["uuid"] = uuidv4();

    Object.keys(schema.properties).map(item => {
        if (item !== "uuid") {
            defaults[item] =
                checkRenderForProvider(item, schema.properties) &&
                schema.properties[item]
                    ? (schema.properties[item].convert
                          ? schema.properties[item].default / 100
                          : schema.properties[item].default) ||
                      checkDefaultForType(schema.properties[item].type)
                    : null;
        }
    });

    defaults["id"] = "Glob-Jackpot01";

    return defaults;
});
